import type { FaireProductEntity } from "../../entity_types/product";

export const p_tybsy34zmw: FaireProductEntity = {
  token: "p_tybsy34zmw",
  type: "product",
  name: "Tahini Sesame Paste  - Once Again",
  brandToken: "b_b2rsmv9db5",
  brandName: "Alive Herbals",
  imageUrl:
    "https://cdn.faire.com/fastly/686c7e9995f3e53db2fb40efb7982cf96963641aa0143e34e37af279bd4cb472.jpeg",
  galleryImageUrls: [],
  priceDollars: 13.5,
  description:
    "Tahini is a type of sauce or paste made from ground sesame seeds. May Support Healthy Bones. May Reduce Inflammation. Good Source of Fiber. Buy at the Alive Herbals.",
  tags: [],
  msrpDollars: 27,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:17.790Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
